module.exports = __webpack_public_path__ + "img/profile.7ad81db7.jpg";